module.exports = __webpack_public_path__ + "img/loader-black.3981a5af.gif";